module.exports = __webpack_public_path__ + "img/00004.d477648c.webp";